import { useMemo } from 'react';
import { get } from 'lodash';
import { checkOnlyDateFormatAndUpdateFormat, currentDateFormat, DATE_FORMAT_MAPPING, DATE_FORMATS } from '../../../../utils/transformChartsAndTableData';

const useTransformChartData = (backendData, options = {}) => {
    const {
        summaryColumnMap = { value: 'Total', subValue: 'Delta' },
        excludeColumns = [],
        rowConfig = {},
        defaultColor = '#7cb5ec',
        defaultSubLabel = 'vs Benchmark'
    } = options;

    return useMemo(() => {
        if (!backendData || !backendData.columns || !backendData.rows || !backendData.metric_data) {
            return [];
        }

        const { columns, rows, metric_data } = backendData;

        const valueIndex = columns.indexOf(summaryColumnMap.value);
        const subValueIndex = columns.indexOf(summaryColumnMap.subValue);

        const summaryColumns = Object.values(summaryColumnMap);
        const timeSeriesIndices = columns
            .map((col, index) => (summaryColumns.includes(col) || excludeColumns.includes(col) ? -1 : index))
            .filter(idx => idx !== -1);

        const categories = timeSeriesIndices.map(idx => checkOnlyDateFormatAndUpdateFormat(columns[idx], DATE_FORMAT_MAPPING[currentDateFormat(columns[idx], DATE_FORMATS)]));

        return rows.map((rowName, rowIndex) => {
            const rowData = metric_data[rowIndex] || [];
            const config = rowConfig[rowName] || {};

            const sparklineData = timeSeriesIndices.map(idx => rowData[idx]);
            const value = valueIndex !== -1 ? rowData[valueIndex] : null;
            const subValue = subValueIndex !== -1 ? rowData[subValueIndex] : null;

            const formattedValue = config.formatValue ? config.formatValue(value) : value;
            const formattedSubValue = config.formatSubValue ? config.formatSubValue(subValue) : subValue;

            return {
                id: rowName,
                label: config.label || rowName,
                value: formattedValue,
                subValue: formattedSubValue,
                subLabel: config.subLabel || defaultSubLabel,
                color: config.color || defaultColor,
                subValueColor: config.subValueColor || (subValue < 0 ? '#d32f2f' : '#388e3c'),
                sparklineData,
                mainChartData: sparklineData,
                categories
            };
        });
    }, [backendData, options]);
};

export default useTransformChartData;
